/* Navigation behavior only. Native forms and consent-aware tracking stay separate. */
(function () {
  'use strict';
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var menu = document.querySelector('.studio-menu[open]');
    if (menu) { menu.open = false; menu.querySelector('summary').focus(); }
  });
  document.addEventListener('click', function (event) {
    var menu = document.querySelector('.studio-menu[open]');
    if (menu && (!menu.contains(event.target) || event.target.closest('a'))) menu.open = false;
  });
})();

// Keep the Inbox launcher clear of mobile inquiry and purchase controls.
(function () {
  if (!('IntersectionObserver' in window)) return;
  var visible = new Set();
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) visible.add(entry.target);
      else visible.delete(entry.target);
    });
    document.body.classList.toggle('studio-conversion-visible', visible.size > 0);
  }, { rootMargin: '40px 0px', threshold: 0 });
  function observe(root) {
    root.querySelectorAll('.studio-inquiry-form, .studio-home-hero .studio-actions, product-form-component, .buy-buttons-block').forEach(function (el) { observer.observe(el); });
  }
  observe(document);
  document.addEventListener('shopify:section:load', function (event) { observe(event.target); });
})();
